// removed by extract-text-webpack-plugin
module.exports = {"change-box-left":"_3OeWeyD78yBX3iCgZFhtul_0","change-box-right":"_1iv3NNBwCKYrB29COAoyIt_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6c33c804","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/config/node/components/VmsChangeHistPopup.vue
// module id = cNUd
// module chunks = 75